<div class="n-breadcrumb d-flex align-items-center justify-content-between">
  <ol class="breadcrumb m-0 bg-transparent p-0">
    <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
    <li class="breadcrumb-item"><a href="/#/reports/home">Reports</a></li>
    <li class="breadcrumb-item active">{{pageTitle}}</li>
  </ol>
</div>

<h3 class="mt-4 font-weight-light">{{pageTitle}}</h3>
<style>
  .ui-table-scrollable-header-box {
    margin: auto !important;
  }
</style>
<div class="dash-tiles">
  <div class="row">
    <div class="col-xl-8">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-blue h-100">
        <div class="card-header">Dealers By Client
       
        </div>
        <div class="card-body table-wrapper-scroll-y my-custom-scrollbar">

          <google-chart type="ColumnChart" [options]="clientChartOptions" [columns]="clientChartColumns"
            [data]="dealerCountByClientData">
          </google-chart>
        </div>
      </div>
    </div>
    <div class="col-xl-4">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-blue h-100 ">
        <div class="card-header">Total Dealers</div>
        <div class="card-body"><p  style="font-size: 68px; margin-top: 40px; margin-left: 100px;">
          <a href="javascript:void(0)" (click)="downloadDealers()" title="Download Dealers">{{totalDealerCount| number}}</a>
        </p></div>
      </div>
    </div>
    <div class="col-xl-12 dash-margin" style="height: 550px;">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-blue h-100">
        <div class="card-header">Dealers By OEM
        
        </div>
        <div class="card-body">
          <google-chart type="BarChart" [options]="OemChartOptions" [columns]="chartColumns"
            [data]="dealerCountByOemData">
          </google-chart>
        </div>
      </div>
    </div>
    <div class="col-xl-12 dash-margin" style="height: 550px;">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-blue h-100">
        <div class="card-header">Dealers By DMS Source
       
        </div>
        <div class="card-body">
          <google-chart type="BarChart"  [options]="SourceChartOptions" [columns]="sourceChartColumns"
            [data]="dealerCountBySourceData">
          </google-chart>
        </div>
      </div>
    </div>
  